import { render, staticRenderFns } from "./TrxSummeryTab.vue?vue&type=template&id=562a80ee"
import script from "./TrxSummeryTab.vue?vue&type=script&lang=js"
export * from "./TrxSummeryTab.vue?vue&type=script&lang=js"
import style0 from "./TrxSummeryTab.vue?vue&type=style&index=0&id=562a80ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports